<template>
    <div>
        <HeaderSection icon="fas fa-user-plus" title="Agregar usuario">
            <template slot="buttons">
                <el-button
                    size="medium"
                    type="danger"
                    icon="el-icon-arrow-left"
                    @click="$router.push('/administracion/usuarios')">
                    Regresar
                </el-button>
            </template>
        </HeaderSection>

        <el-form ref="user-form" :model="userForm" label-width="120px" label-position="top">
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item
                        label="Tipo de usuario"
                        prop="isLdap"
                        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                        <el-switch
                            v-model="userForm.isLdap"
                            active-text="Interno"
                            inactive-color="#13322B"
                            active-color="#9d2438"
                            inactive-text="Externo">
                        </el-switch>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item
                        label="Usuario"
                        prop="username"
                        :rules="[{ required: true, message: 'Este campo es obligatorio', trigger: 'change' },
                                        { pattern:/^[ña-z-ú_]+?$/, message: 'Ingrese sólo letras minúsculas' }
                                ]">
                        <el-input v-my-only-alphanumeric="{maxChars: 70}" v-model="userForm.username" @change="checkUser(userForm.username, userForm.isLdap)"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item
                        label="Correo electrónico"
                        prop="email"
                        :rules="[{ required: true, message: 'Este campo es obligatorio', trigger: 'blur' },
                                { type: 'email', message: 'Introduzca un correo valido', trigger: 'blur' },
                                { max: 70, message: 'Este campo debería ser de máximo 70 caracteres', trigger: 'blur' }]">
                        <el-input v-my-only-alphanumeric="{maxChars: 70}" :disabled="userForm.isLdap" v-model="userForm.email"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item
                        label="Apellido Paterno"
                        prop="firstName"
                        :rules="[{ required: true, message: 'Este campo es obligatorio', trigger: 'blur' },
                                    { max: 70, message: 'Este campo debería ser de máximo 70 caracteres', trigger: 'blur' },
                                    {pattern:/^[ña-zÀ-úÑA-Z0-9 _]+?$/,message: 'Ingrese sólo letras y/o números'}]">

                        <el-input v-my-only-alphanumeric="{maxChars: 70}" :disabled="userForm.isLdap" v-model="userForm.firstName" class="input-with-select">
                            <el-select class="el-select-custom" v-model="userForm.cat_user_prefix_id" slot="prepend"
                                       placeholder="tít.">
                                <el-option
                                    v-for="prefix in prefixes"
                                    :key="prefix.id"
                                    :label="prefix.name"
                                    :value="prefix.id">
                                </el-option>
                            </el-select>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="Apellido Materno"
                                  :rules="{pattern:/^[ña-zÀ-úÑA-Z0-9 _]+?$/,message: 'Ingrese sólo letras y/o números'}">
                        <el-input v-my-only-alphanumeric="{maxChars: 70}" :disabled="userForm.isLdap" v-model="userForm.secondName"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item
                        label="Nombre(s)"
                        prop="name"
                        :rules="[{ required: true, message: 'Este campo es obligatorio', trigger: 'blur' },
                                    { max: 70, message: 'Este campo debería ser de máximo 70 caracteres', trigger: 'blur' },
                                    {pattern:/^[ña-zÀ-úÑA-Z0-9 _]+?$/,message: 'Ingrese sólo letras y/o números'}]">

                        <el-input v-my-only-alphanumeric="{maxChars: 70}" :disabled="userForm.isLdap" v-model="userForm.name"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item
                        label="Oficina"
                        prop="cat_office_id"
                        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                        <el-select
                            v-model="userForm.cat_office_id"
                            filterable
                            clearable
                            placeholder="Seleccionar"
                            style="width: 100% !important;">
                            <el-option
                                v-for="office in offices"
                                :key="office.id"
                                :label="office.name"
                                :value="office.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item
                        label="Perfil"
                        prop="cat_profile_id"
                        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                        <el-select
                            v-model="userForm.cat_profile_id"
                            filterable
                            @change="setUserRoles(userForm.cat_profile_id)"
                            placeholder="Seleccionar"
                            style="width: 100%">
                            <el-option
                                v-for="profile in profiles"
                                :key="profile.id"
                                :label="profile.name"
                                :value="profile.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item
                        label="Usuario Extranjero"
                        prop="isLdap"
                        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                        <el-switch

                            v-model="userForm.isForeign"
                            active-text="Extranjero"
                            inactive-color="#13322B"
                            active-color="#9d2438"
                            inactive-text="Nacional">
                        </el-switch>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="24" v-if="userForm.cat_profile_id == 5">
                    <el-form-item label="Banco"
                                  prop="cat_bank_id"
                                  :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                        <el-select
                            v-model="userForm.cat_bank_id"
                            filterable
                            placeholder="Seleccionar"
                            style="width: 100%">
                            <el-option
                                v-for="bank in banks"
                                :key="bank.id"
                                :label="bank.name"
                                :value="bank.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                </el-col>
                <el-col :span="24" v-if="userForm.cat_profile_id == 6">
                    <el-form-item label="No. de Corredor Público"
                                  prop="publicHallNumber"
                                  :rules="[{ required: true, message: 'Este campo es obligatorio', trigger: 'blur' },
                                    { max: 70, message: 'Este campo debería ser de máximo 70 caracteres', trigger: 'blur' },
                                    {pattern:/^[ña-zÀ-úÑA-Z0-9 _]+?$/,message: 'Ingrese sólo letras y/o números'}]">
                        <el-input v-my-only-alphanumeric="{maxChars: 70}" v-model="userForm.publicHallNumber"/>
                    </el-form-item>

                </el-col>
                <el-col :span="24" v-if="userForm.cat_profile_id == 7">
                    <el-form-item label="Notaria"
                                  prop="cat_notary_id"
                                  :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                        <el-select
                            v-model="userForm.cat_notary_id"
                            filterable
                            placeholder="Seleccionar"
                            style="width: 100%">
                            <el-option
                                v-for="notary in notaries"
                                :key="notary.id"
                                :label="notary.name && notary.state && notary.state.name ?
                                    notary.name +' '+notary.state.name : notary.name"
                                :value="notary.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                </el-col>
            </el-row>
            <el-row :gutter="20" v-if="!userForm.isLdap">
                <el-col :span="12">
                    <el-form-item
                        label="Contraseña"
                        prop="password"
                        :rules="[
                        {
                          required: true,
                          message: 'Escriba una contraseña', trigger: 'change'
                        },
                        {
                          min: 12,
                          message: 'Escriba al menos 12 caracteres', trigger: 'change'
                        },
                        {
                          pattern: '.*[0-9].*',
                          message: 'Indique al menos un número', trigger: 'change'
                        },
                        {
                          pattern: '.*[a-z]',
                          message: 'Indique al menos una minuscula', trigger: 'change'
                        },
                        {
                          pattern: '.*[A-Z]',
                          message: 'Indique al menos una mayúscula', trigger: 'change'
                        },
                        {
                          pattern: '.*[¡!@#$%^&*(),.¿?:{}|<>]',
                          message: 'Indique al menos un carácter especial', trigger: 'change'
                        }
                      ]">
                        <template>
                            <password style="background-color: #ffffff !important;"
                                      :badge="false"
                                      :toggle="true"
                                      v-model="userForm.password"/>
                        </template>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item
                        label="Repetir contraseña"
                        prop="passwordConfirm"
                        :rules="[
                        {
                          required: true,
                          message: 'Escriba una contraseña', trigger: 'change'
                        },
                        {
                          min: 12,
                          message: 'Escriba al menos 12 caracteres', trigger: 'change'
                        },
                        {
                          pattern: '.*[0-9].*',
                          message: 'Indique al menos un número', trigger: 'change'
                        },
                        {
                          pattern: '.*[a-z]',
                          message: 'Indique al menos una minuscula', trigger: 'change'
                        },
                        {
                          pattern: '.*[A-Z]',
                          message: 'Indique al menos una mayúscula', trigger: 'change'
                        },
                        {
                          pattern: '.*[¡!@#$%^&*(),.¿?:{}|<>]',
                          message: 'Indique al menos un carácter especial', trigger: 'change'
                        }
                      ]">
                        <el-input
                            v-model="userForm.passwordConfirm"
                            show-password
                            @change="checkPassword(userForm.password, userForm.passwordConfirm)"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <br>
            <el-row class="custom-header" type="flex" justify="space-between">
                <el-col>
                    <h3 class="custom-title">
                        <i class="fas fa-lock"></i>
                        Permisos
                    </h3>
                </el-col>
            </el-row>
            <br>
            <el-row :gutter="20">
                <el-col :span="8">
                    <a href=""
                       style="text-decoration: none"
                       @click.prevent="openPermission('Módulo de nAdministración', 1)">
                        <el-card style="background: #9d2438; color: whitesmoke; text-align: center">
                            Módulo de Administración
                        </el-card>
                    </a>
                </el-col>
                <el-col :span="8">
                    <a href=""
                       style="text-decoration: none"
                       @click.prevent="openPermission('SIPAC27', 2)">
                        <el-card style="background: #13322B; color: whitesmoke; text-align: center">
                            SIPAC27
                        </el-card>
                    </a>
                </el-col>
            </el-row>
            <br>
            <el-row :gutter="20">
                <el-col :span="24" align="end">
                    <el-button
                        size="medium"
                        type="danger"
                        icon="el-icon-arrow-left"
                        @click="$router.push('/administracion/usuarios')">
                        Cancelar
                    </el-button>
                    <el-button
                        type="primary"
                        size="medium"
                        icon="far fa-save"
                        @click="submitForm('user-form')">
                        Guardar
                    </el-button>
                </el-col>
            </el-row>
        </el-form>
        <div id="comboTmp" style="height: 20px"></div>
        <Permissions
            profile="userProfile"
            :title="title"
            :showDialog="showPermissions"
            :system="system"
            :userRoles="userRoles"
            @save-permissions="setPermissionsBy(...arguments)"
            @close-dialog="showPermissions = false"/>
    </div>
</template>

<script>
    import HeaderSection from '../../../partials/HeaderSection';
    import password from 'vue-password-strength-meter'
    import Permissions from './partials/Permissions';

    export default {
        props: {
            userthis: {}
        },
        components: {
            HeaderSection,
            password,
            Permissions
        },

        computed: {
            userInfo() {
                return this.$store.state.user;
            },

        },

        data() {
            return {
                isLdap: false,
                isUserValid: false,
                offices: [],
                profiles: [],
                banks: [],
                notaries: [],
                userForm: {
                    isLdap: true
                },
                prefixes: [],
                permissions: [],
                userId: 0,
                userRoles: [],
                title: '',
                showPermissions: false,
                disabledFieldValue: false,
                system: 1,
                SpcPermissions: [],
                SirciamPermissions: [],

                defaultProps: {
                    children: 'children',
                    label: 'label'
                }
            };
        },
        created() {
            this.showLoading();

            axios.get('/api/users/create').then(response => {

                this.profiles = response.data.profiles;
                this.offices = response.data.offices;
                this.prefixes = response.data.prefixes;
                this.banks = response.data.banks;
                this.notaries = response.data.notaries;
                this.hideLoading();
            }).catch(error => {
                this.hideLoading();

                this.$notify({
                    type: 'error',
                    message: 'No se pudo completar la acción'
                });
            });
        },

        methods: {
            setUserRoles(profile) {
                this.userRoles = [];
                this.$store.dispatch(
                    'loading/spinner',
                    { msg: 'Asignando permisos...', status: true },
                    { root: true }
                );
                axios.get('/api/get-permission',{params: {cat_profile_id: profile}}).then(response => {
                    if (response.data.success) {
                        this.userRoles = response.data.distribution;
                    }
                    this.hideLoading();
                }).catch(error => {
                    this.hideLoading();
                    console.log('setUserRoles', error);
                    this.$notify({
                        type: 'error',
                        message: 'No se pudo completar la acción'
                    });
                });
                return this.userRoles
            },

            showLoading() {
                this.$store.dispatch('loading/spinner',
                    {msg: 'Cargando Datos...', status: true}, {root: true});
            },
            hideLoading() {
                this.$store.dispatch('loading/spinner', {}, {root: true});
            },

            selectUserType() {
                this.userForm = {sre_cat_office_id: ''};
                this.isUserValid = false;
                this.$refs['user-form'].clearValidate();
                this.$refs['user-form'].resetFields();
            },

            openPermission(title, system) {
                this.title = title;
                this.system = system;
                this.showPermissions = true;
            },

            checkUser(username, isLdap) {
                if (username) {
                    let data = {
                        username: username,
                        isLdap: isLdap
                    };

                    this.showLoading();

                    axios.post('/api/users/check-user', data).then(response => {

                        if (response.data.user && response.data.user.isLdap) {
                            this.userForm = response.data.user;
                        }else{
                            this.userForm = response.data.user
                        }
                        this.hideLoading();
                        if(!response.data.success){
                            this.userForm.username = '';
                        }
                        this.$message({
                            type: response.data.success ? 'success' : 'error',
                            message: response.data.message
                        });

                    }).catch(error => {
                        this.userForm = {};
                        this.hideLoading();
                        this.$message({
                            type: 'error',
                            message: 'El usuario que ingresó no es válido o ya existe en el sistema, favor de verificar.'
                        });
                    });
                } else {
                    this.isUserValid = false;
                    this.$message({
                        type: 'error',
                        message: 'Ingrese un usuario válido'
                    });
                }
            },

            checkPassword(pass, confirmPass) {

                if (pass !== confirmPass) {
                    this.$notify({
                        type: 'warning',
                        title: 'Contraseña',
                        message: 'La contraseña no coincide, intente de nuevo.'
                    });
                }
            },

            setPermissionsBy(system, permissions) {
                if (system === 1) {
                    this.SpcPermissions = permissions;
                } else if (system === 2) {
                    this.SirciamPermissions = permissions;
                }
            },

            submitForm(formName) {
                if (this.userForm.password !== this.userForm.passwordConfirm) {
                    this.$notify({
                        type: 'warning',
                        title: 'Contraseña',
                        message: 'La contraseña no coincide, intente de nuevo.'
                    });

                    return false
                } if(!this.userForm.cat_user_prefix_id){
                    this.$notify({
                        type: 'warning',
                        title: 'Atención',
                        message: 'El tít. es un campo obligatorio.'
                    });

                    return false
                }else {

                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            this.userForm.permissions = [
                                ...this.userRoles
                            ];
                            this.userRoles = this.userForm.permissions;
                            axios.post('/api/users', this.userForm).then(response => {
                                if(response.data.success){
                                    this.$notify({
                                        type: 'success',
                                        title: 'Éxito',
                                        message: response.data.message
                                    });
                                    this.$refs['user-form'].clearValidate();
                                    this.$refs['user-form'].resetFields();
                                    this.hideLoading();
                                    this.$router.push('/administracion/usuarios')
                                }else{
                                    this.$notify({
                                        type: 'warning',
                                        title: 'Atención',
                                        message: response.data.message
                                    });
                                }

                            }).catch(error => {
                                this.hideLoading();
                                this.$notify({
                                    type: 'error',
                                    title: 'Error',
                                    message: 'No fue posible registrar al usuario, inténtelo nuevamente otra.'
                                });
                            });

                        } else {
                            this.$notify({
                                type: 'warning',
                                title: 'Campos Requeridos',
                                message: 'Por favor complete todos los campos requeridos.'
                            });

                            return false;
                        }
                    });
                }
            },

            pad(number, length) {
                let str = '' + number;

                while (str.length < length) {
                    str = '0' + str;
                }

                return str;
            },

        },

    };
</script>

<style>
</style>
